import { Address } from 'viem';

/**
 * Converts a string to lowercase while preserving literal type information
 */
export function toLowerCase<S extends string>(str: S): Lowercase<S> {
  return str.toLowerCase() as Lowercase<S>;
}

/**
 * Converts a string to uppercase while preserving literal type information
 */
export function toUpperCase<S extends string>(str: S): Uppercase<S> {
  return str.toUpperCase() as Uppercase<S>;
}

export function capitalize(str: string): string {
  if (str.length === 0) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function truncate(str: string, maxLength = 6): string {
  if (str.length <= maxLength) return str;
  // Subtract one to account for the space required by ellipsis
  return str.slice(0, maxLength - 1) + '...';
}

export function truncateAddress(address: Address): string {
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}
